import { GetStaticProps } from 'next'

import { Layout } from '~/components/Layout'
import { PAGE_ROUTES } from '~/constants'
import { getOverallStargazers } from '~/lib/useStargazers'
import { getLayoutProps } from '~/lib/layout'
import { PageProps } from '~/lib/types'
import { useOSName } from '~/lib/os'
import { getDownloadButtonLabel } from '~/lib/download/download'
import DesktopHero from '~/sections/DesktopHero/DesktopHero'
import Community from '~/sections/Community/Community'
import Companies from '~/sections/Companies/Companies'
import PillCTA from '~/sections/PillCTA/PillCTA'
import TweetSection from '~/sections/Tweets/TweetSection'
import { GITHUB_ALL_PUBLIC_REPOS } from '~/data'
import { DESKTOP_SHARE_IMAGE } from '~/lib/seo'

export const getStaticProps: GetStaticProps = () => ({
  props: {
    orgRepoStargazers: getOverallStargazers(GITHUB_ALL_PUBLIC_REPOS),
    layoutProps: getLayoutProps(),
  },
})

interface Props extends PageProps {
  orgRepoStargazers: number | null
}

const DesktopPage: React.FC<Props> = ({ orgRepoStargazers, layoutProps }) => {
  const osName = useOSName()

  return (
    <Layout
      {...layoutProps}
      title='Desktop & Web app'
      description='All the user-friendliness of our Terminal version, now wrapped up in a sleek graphical interface.'
      shareImage={DESKTOP_SHARE_IMAGE}
    >
      <DesktopHero />
      <PillCTA
        heading='HTTPie&nbsp;for&nbsp;Mac, Windows,&nbsp;and&nbsp;Linux'
        description='Work locally and without distraction with our dedicated app.'
        button={{
          'text': getDownloadButtonLabel(osName),
          'link': PAGE_ROUTES.DOWNLOAD,
          'data-track': 'cta:get-the-app:from-app-page',
        }}
      />
      <TweetSection />
      <Companies />
      <Community orgRepoStargazers={orgRepoStargazers} showOpenSource={false} />
    </Layout>
  )
}

export default DesktopPage
